/**
 * Domain types for saved mazes.
 */

export type MazeType = 'radial' | 'image' | 'template';

export interface SavedMaze {
  id: string;
  familyId: string;
  mazeType: MazeType;
  difficulty: string;
  geometryBlobUrl: string;
  /** Geometry blob url per difficulty (easy/medium/hard/expert); absent for older mazes. */
  geometryUrls?: Record<string, string>;
  thumbnailBlobUrl: string;
  templateId?: string;
  sourceImageBlobUrl?: string;
  createdAt: string;
}
